import Button from './button';

export default class Primary extends Button {
  get buttonClass() {
    return 'ds-button--primary';
  }
}
